import * as React from "react"
import * as ReactDOM from "react-dom"

interface INewsAllListViewProps {
    
    WebpartTitle: string;
    OpenInNewWindow: boolean;
    DateFormat: string;
    itemProperties: {
        Id: number;
        Title: string;
        PageLink: string;
        ImageSource: string;
        Date: string;
    };
    initialState: NewsAllListViewModel<NewsAllListViewItemModel>;
}

class NewsAllListViewModel<T> {
    WebpartTitle: string;
    OpenInNewWindow: boolean;
    DateFormat: string;
    items: Array<T>;
    constructor() {
        this.items = new Array<T>();
    }
}

class NewsAllListViewItemModel {
    Id: number;
    Title: string;
    PageLink: string;
    ImageSource: string;
    Date: string;
}

export class NewsAllListView extends React.Component<INewsAllListViewProps, NewsAllListViewModel<NewsAllListViewItemModel>>{
    constructor(props: INewsAllListViewProps) {
        super(props);
        var locale = _spPageContextInfo.currentCultureName.substring(0, 2);
        window["moment"].locale(locale);
        this.state = (!this.props.initialState) ? new NewsAllListViewModel<NewsAllListViewItemModel>() : this.props.initialState;
    }

    componentDidMount() {

    }


    render() {
        return <section className="news d-flex">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="news-title">
                            <h5>{this.state.WebpartTitle}</h5>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {this.state.items.map((value, index, array) => {
                        return <div className="col-lg-3">
                            <div className="news-item">
                                <div className="card news-card">
                                    <div className="visuals">
                                        <img src={value.ImageSource} className="card-img-top" alt="..." />
                                    </div>
                                    <div className="card-body">
                                        <p className="card-date"><i className="bi bi-calendar3"></i>{window["moment"](value.Date).format(this.state.DateFormat ? this.state.DateFormat : "DD.MM.YYYY")}</p>
                                        <p className="card-text">{value.Title }
                                        </p>
                                        <a href={value.PageLink} className=""><i className="bi bi-arrow-right-short"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    })}
                </div>
            </div>
        </section>


    }
}




// WEBPACK FOOTER //
// ./Views/src/Common/news-all-list-view.tsx